// extracted by mini-css-extract-plugin
module.exports = {"terms-and-policy-link-small":"signIn_terms-and-policy-link-small__3jfg3"};